export const normalizeFilename = (filename: string) => {
  const split = filename.split(".");
  let extension = split.pop();
  const name = split.join(".");
  if (extension) {
    extension = extension.toLowerCase();
  }
  return name + (extension ? "." + extension : "");
};
